import { Injectable } from '@angular/core';

export interface CompanyLicenseTokenOptions {
  onWarning?: () => void;
  onLicenseBlock?: () => void;
  onGenericError?: (message: string) => void;
}

@Injectable()
export class CompanyLicenseLoginService {
  warningData: any = { show: false, message: '' };
  errorData: any = { show: false, message: '' };
  private proceedCallback: (() => void) | null = null;

  handleTokenResponse(data: any, onProceed: () => void, options?: CompanyLicenseTokenOptions) {
    if (data && data.status) {
      if (data.license_warning === true) {
        this.proceedCallback = onProceed;
        this.warningData = {
          show: true,
          message: data.warning_message ? data.warning_message : ''
        };
        if (options && options.onWarning) {
          options.onWarning();
        }
        return;
      }
      onProceed();
      return;
    }

    if (data && data.license_status) {
      this.errorData = {
        show: true,
        message: data.message ? data.message : 'This company cannot be accessed right now.'
      };
      if (options && options.onLicenseBlock) {
        options.onLicenseBlock();
      }
      return;
    }

    if (options && options.onGenericError) {
      options.onGenericError(data && data.message ? data.message : 'Something went wrong.');
    }
  }

  acknowledgeWarning() {
    this.warningData.show = false;
    if (this.proceedCallback) {
      let callback = this.proceedCallback;
      this.proceedCallback = null;
      callback();
    }
  }

  closeError() {
    this.errorData.show = false;
  }

  reset() {
    this.warningData = { show: false, message: '' };
    this.errorData = { show: false, message: '' };
    this.proceedCallback = null;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4096685381/src/src/app/shared/services/company-license-login.service.ts